import { IconHighlightedSizeType, } from '@kubit/web-ui-components/iconHighlighted/types';
import { commonStylesExtraExtraSmall, commonStylesExtraSmall, commonStylesLarge, commonStylesMedium, commonStylesSmall, } from '../commonStyles';
import { IconHighlightedVariantType } from '../variants';
export const getCircleWithoutBorderStyles = (FOUNDATIONS, FONT) => {
    return {
        [IconHighlightedVariantType.CIRCLE_WITHOUT_BORDER]: {
            [IconHighlightedSizeType.EXTRA_EXTRA_SMALL]: {
                ...commonStylesExtraExtraSmall(FOUNDATIONS),
                container: {
                    ...commonStylesExtraExtraSmall(FOUNDATIONS).container,
                    border_radius: FOUNDATIONS.radius_1000,
                },
            },
            [IconHighlightedSizeType.EXTRA_SMALL]: {
                ...commonStylesExtraSmall(FOUNDATIONS),
                container: {
                    ...commonStylesExtraSmall(FOUNDATIONS).container,
                    border_radius: FOUNDATIONS.radius_1000,
                },
            },
            [IconHighlightedSizeType.SMALL]: {
                ...commonStylesSmall(FOUNDATIONS),
                container: {
                    ...commonStylesSmall(FOUNDATIONS).container,
                    border_radius: FOUNDATIONS.radius_1000,
                },
            },
            [IconHighlightedSizeType.MEDIUM]: {
                ...commonStylesMedium(FOUNDATIONS),
                container: {
                    ...commonStylesMedium(FOUNDATIONS).container,
                    border_radius: FOUNDATIONS.radius_1000,
                },
            },
            [IconHighlightedSizeType.LARGE]: {
                ...commonStylesLarge(FOUNDATIONS),
                container: {
                    ...commonStylesLarge(FOUNDATIONS).container,
                    border_radius: FOUNDATIONS.radius_1000,
                },
            },
        },
    };
};
//# sourceMappingURL=circleWithoutBorder.js.map